var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system-uicons:link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.49981 7.5003L10.4998 6.5003C11.0302 5.96987 11.7497 5.67188 12.4998 5.67188C13.25 5.67188 13.9694 5.96987 14.4998 6.5003C15.0302 7.03074 15.3282 7.75016 15.3282 8.5003C15.3282 9.25045 15.0302 9.96987 14.4998 10.5003L13.4998 11.5003M10.4998 14.5003L9.49981 15.5003C8.96938 16.0307 8.24996 16.3287 7.49981 16.3287C6.74967 16.3287 6.03025 16.0307 5.49981 15.5003C4.96938 14.9699 4.67139 14.2504 4.67139 13.5003C4.67139 12.7502 4.96938 12.0307 5.49981 11.5003L6.49981 10.5003M7.49981 13.5003L12.4998 8.5003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.e589cde9270fe1fbbd1dc68e737e0a5f.svg";
export { ForwardRef as ReactComponent };